import TabsSlide from './TabsSlide';

export default TabsSlide;
